import { render, staticRenderFns } from "./ColdClientAssignModal.vue?vue&type=template&id=61014708&scoped=true&"
import script from "./ColdClientAssignModal.vue?vue&type=script&lang=js&"
export * from "./ColdClientAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./ColdClientAssignModal.vue?vue&type=style&index=0&id=61014708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61014708",
  null
  
)

export default component.exports